import type { RouteObject } from "react-router";

import { ModulesHeaderView, ModulesView } from "./ModulesView.tsx";

export const projectsRoute: RouteObject = {
  path: "modules",
  Component: ModulesView,
  handle: { header: ModulesHeaderView },
};
